<script lang="ts">
  import { createEventDispatcher, onMount } from 'svelte';

  import ZoneRoleSelect from '@/comps-sdk/components/zone-role-select';
  import { GAME_TYPE } from '@/comps-sdk/constants';
  import { getMainUserInfo } from '@/comps-sdk/modules/user';
  import { isGameMsdk } from '@/comps-sdk/utils/platform';

  export let data: any = {};

  const dispatch = createEventDispatcher();

  onMount(() => {
    const { gameAppId = '', scene, gameType, alias } = data;

    // 参数检查
    if (scene === 'act') {
      if (!gameAppId && gameType === GAME_TYPE.mobile) {
        throw new Error('中台区服组件未接收到手游appid');
      }
      if (!alias && gameType === GAME_TYPE.client) {
        throw new Error('中台区服组件未接收到端游别名alias');
      }
    }

    // 拉起区服
    const zone: any = ZoneRoleSelect({
      scene, // 场景
      gameType,
      alias,
      gameAppId: String(gameAppId), // 游戏appid
      getUserInfoCb: async () => {
        // 用于显示用户信息头像，选填
        if (isGameMsdk()) {
          return null;
        }
        const userInfo = await getMainUserInfo();
        const { code, result } = userInfo;
        if (code !== 0) {
          return {
            type: '',
            nickname: '',
            headImgUrl: '',
          };
        }

        return result;
      },
    });

    // 确认成功事件
    zone.$on('confirm', async (params: any) => {
      dispatch('confirm', params);
    });

    // 手动关闭事件
    zone.$on('close', async () => {
      dispatch('close');
    });
  });
</script>
